import React from "react";

const OxygenSaturationBody = () => {
  return (
    <div>
      <h2>Oxygen Saturation Body Content</h2>
    </div>
  );
};

export default OxygenSaturationBody;
